export default __webpack_public_path__ + "assets/favicon/S_favicon_error.4a12b59e.ico";